import { waLink } from "@/lib/whatsapp";
import { INSTAGRAM } from "@/lib/social";
import { scrollToHash } from "@/components/Header";

const Footer = () => (
    <footer data-testid="main-footer" className="bg-white border-t border-black/10 px-6 md:px-12 pt-20 pb-28 md:pb-12">
        <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-12">
                <div>
                    <div className="flex items-baseline gap-3">
                        <span className="font-editorial italic text-5xl md:text-6xl text-[#6A2022]">LC</span>
                        <span className="text-xs tracking-[0.4em] uppercase text-[#0A0A0A]/70">Production</span>
                    </div>
                    <p className="mt-6 text-[10px] tracking-[0.45em] uppercase text-[#0A0A0A]/40" data-testid="footer-tagline">
                        Música. Experiência. Memória.
                    </p>
                </div>

                <nav className="flex flex-wrap gap-x-8 gap-y-4" data-testid="footer-nav">
                    <a href="#cerimonial" onClick={(e) => { e.preventDefault(); scrollToHash("#cerimonial"); }} data-testid="footer-link-cerimonial" className="text-[11px] tracking-[0.25em] uppercase text-[#0A0A0A]/60 hover:text-[#6A2022] transition-colors duration-300">
                        LC Cerimonial
                    </a>
                    <a href="#astrolive" onClick={(e) => { e.preventDefault(); scrollToHash("#astrolive"); }} data-testid="footer-link-astrolive" className="text-[11px] tracking-[0.25em] uppercase text-[#0A0A0A]/60 hover:text-[#6A2022] transition-colors duration-300">
                        AstroLive
                    </a>
                    <a href={INSTAGRAM.cerimonial} target="_blank" rel="noopener noreferrer" data-testid="footer-link-instagram" className="text-[11px] tracking-[0.25em] uppercase text-[#0A0A0A]/60 hover:text-[#6A2022] transition-colors duration-300">
                        Instagram Cerimonial
                    </a>
                    <a href={INSTAGRAM.astrolive} target="_blank" rel="noopener noreferrer" data-testid="footer-link-instagram-astrolive" className="text-[11px] tracking-[0.25em] uppercase text-[#0A0A0A]/60 hover:text-[#6A2022] transition-colors duration-300">
                        Instagram AstroLive
                    </a>
                    <a href={waLink("geral")} target="_blank" rel="noopener noreferrer" data-testid="footer-link-whatsapp" className="text-[11px] tracking-[0.25em] uppercase text-[#0A0A0A]/60 hover:text-[#6A2022] transition-colors duration-300">
                        WhatsApp
                    </a>
                    <a href="#contato" onClick={(e) => { e.preventDefault(); scrollToHash("#contato"); }} data-testid="footer-link-contato" className="text-[11px] tracking-[0.25em] uppercase text-[#0A0A0A]/60 hover:text-[#6A2022] transition-colors duration-300">
                        Contato
                    </a>
                </nav>
            </div>

            <div className="mt-16 pt-8 border-t border-black/10 flex flex-col sm:flex-row justify-between gap-4">
                <p className="text-[10px] tracking-[0.3em] uppercase text-[#0A0A0A]/40" data-testid="footer-location">
                    Rio de Janeiro — RJ
                </p>
                <p className="text-[10px] tracking-[0.3em] uppercase text-[#0A0A0A]/40" data-testid="footer-copyright">
                    © LC Production
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
